// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"4ea5f38f","960":"4ea5f38f"}[chunkId] + ".chunk.css";
};